import { G2S } from '../g2s';
import * as api from '../api';

export class BannerService {
    list(request: api.BannerRequest): Promise<api.Banner[]> {
        return new Promise<api.Banner[]>((resolve, reject) => {
            G2S.$http
                .post(
                    '/api/Banner/List',
                    request,
                    {
                        withCredentials: true
                    }
                )
                .then(function (response) {
                    const r = <api.Banner[]>response.data;

                    // #4908
                    if (r
                        && r.length > 0) {
                        const u = '/banner/' + r[0].id + '/area/' + request.displayArea;

                        if (window['ym']
                            && window['__ymCounterIdBanners']) {
                            window['ym'](window['__ymCounterIdBanners'], 'hit', u);
                        }

                        if (G2S.isDev) {
                            console.log('YM hit ' + u);
                        }
                    }

                    resolve(r);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }
}
